<template>
  <div id="allAchievements">
    <div class="tile is-ancestor">
      <div
        class="tile is-parent is-vertical"
        v-for="(achievementsColumn, index) of allAchievements"
        :key="index"
      >
        <article
          class="tile is-child box"
          v-for="(achievement, index) of achievementsColumn.column"
          :key="index"
        >
          <div class="content">
            <h6 class="date">{{achievement.date}}</h6>
            <h4 class="head-title">{{achievement.title}}</h4>
            <h5
              class="details"
              v-for="(detail, index) of achievement.details"
              :key="index"
            >{{detail}}</h5>
            <div class="content description">
              <p v-for="(paragraph, index) of achievement.content" :key="index">{{paragraph}}</p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import allAchievementsJson from "../../public/AllAchievements.json";

export default {
  name: "allAchievements",
  data() {
    return {
      allAchievements: allAchievementsJson.allAchievements
    };
  }
};
</script>

<style scoped>
#allAchievements {
  direction: rtl;
}
.box {
  background-color: #fcfdf1;
  padding: 3.2vh;
}
.date {
  font-weight: 500;
  font-size: 97%;
  color: black;
}
.head-title {
  font-weight: 500;
  font-size: 130%;
  color: black;
}
.details {
  font-weight: 500;
  font-size: 102%;
  color: #14141f;
  /* text-align: justify; */
}
.description {
  text-align: justify;
}
</style>